import React from "react";
import {findDOMNode} from "react-dom";
import Popover from "../../../../../gd-components/gd-popover/popover";
import FieldProto from "../../../../proto/field-proto";

type Props = {
    parent      : any,
    field       : FieldProto
}

export default class FieldPopover_Popover extends React.Component<Props,any> {


    constructor(props:any) {
        super(props);

        this.state = {
            searchString: null
        }
    }

    render() {
        return (
            <Popover attachment="top center"
                     targetAttachment="bottom center"
                     getTargetFunc={()=>findDOMNode(this.props.parent)}
                     onClickOutside={()=>{this.props.parent.hidePopover()}}>

                Proto example popover menu

            </Popover>
        );
    }
}
